@if (vm.showTodaySelection) {
  <section class="today-checkbox-wrapper" [class.selected]="vm.checkedTodaysDate">
    <label class="today-checkbox-label" for="today-checkbox">
      <input
        type="checkbox"
        id="today-checkbox"
        [checked]="checkedTodaysDate()"
        (change)="onCheckboxChanged($event)"
        data-testid="today-checkbox"
        aria-describedby="today-date-description"
      />
      <p class="body" id="today-date-description">Today ({{ formattedTodaysDate | date: 'd MMMM y' }})</p>
    </label>
  </section>
}

<!--if they want to see today checkbox AND its not selected, show calendar picker -->
@if ((vm.showTodaySelection && !vm.checkedTodaysDate) || !vm.showTodaySelection) {
  <section class="flex full-width navigation mb-12" role="toolbar" aria-label="Calendar navigation">
    <p data-testid="displayMonth" class="body bold">
      {{ vm.displayMonth }}
      @if (vm.showSelectedYear) {
        {{ vm.selectedYear }}
      }
    </p>

    <section class="action flex">
      <button
        class="navigation-button"
        type="button"
        aria-label="Previous month"
        (click)="moveMonthBack()"
        [disabled]="disabled || !vm.canGoBackwards || vm.loading"
        data-testid="previous-month"
      >
        <i class="fa-light fa-chevron-left" aria-hidden="true"></i>
      </button>
      <button
        class="navigation-button"
        type="button"
        aria-label="Next month"
        (click)="moveMonthForward()"
        [disabled]="disabled || !vm.canGoForward || vm.loading"
        data-testid="next-month"
      >
        <i class="fa-light fa-chevron-right" aria-hidden="true"></i>
      </button>
    </section>
  </section>

  <section class="calendar-holder" aria-label="Appointment dates calendar" data-testid="calendar">
    <div class="calendar-grid-wrapper">
      <div class="calendar-grid" role="grid" aria-label="Appointment dates">
        <div class="calendar-grid-header" role="row">
          @for (weekday of shortDatesInWeek; track weekday) {
            <div class="calendar-grid-header-cell" role="columnheader">
              <p class="hint">
                {{ weekday }}
              </p>
            </div>
          }
        </div>
        <div class="calendar-grid-body" role="rowgroup">
          @for (week of vm.weekInMonth; track week; let weekIndex = $index) {
            <div class="calendar-grid-row" role="row">
              @for (day of week; track day; let dayIndex = $index) {
                <div
                  class="day-cell"
                  role="gridcell"
                  [class.day-cell-active]="day.isActive"
                  [class.day-cell-active-left]="day.isActive && week[dayIndex - 1]?.isActive"
                  [class.day-cell-active-right]="day.isActive && week[dayIndex + 1]?.isActive"
                  [class.day-cell-active-top]="day.isActive && vm.weekInMonth[weekIndex - 1]?.[dayIndex]?.isActive"
                  [class.day-cell-active-bottom]="day.isActive && vm.weekInMonth[weekIndex + 1]?.[dayIndex]?.isActive"
                >
                  <button
                    type="button"
                    class="day body large"
                    [disabled]="disabled"
                    [tabIndex]="!inCalendarView && day.isActive ? 0 : -1"
                    [class.selected]="value === day.date"
                    [class.inCurrentMonth]="day.isCurrentMonth"
                    [class.isActive]="day.isActive"
                    [attr.data-iscurrentmonth]="day.isCurrentMonth"
                    [attr.data-date]="day.date"
                    [attr.aria-label]="getCalendarDayAriaLabel(day)"
                    [attr.aria-pressed]="value === day.date"
                    [attr.aria-disabled]="!day.isActive || disabled"
                    [attr.data-testid]="day.isActive ? 'calendar-date' : null"
                    (click)="day.isActive ? writeValue(day.date) : null"
                  >
                    <span class="day-label">{{ day.date | date: 'd' }}</span>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    @if (vm.loading) {
      <section class="loading-dates">
        <app-loading-spinner variant="grey" [strokeWidth]="4" [size]="40" />
        <p class="body bold">Our calendar’s loading…</p>
      </section>
    }
  </section>
}
